<template>
  <div class="move-to-stage-btn">
    <a :href="`./${link}`"><slot></slot></a>
  </div>
</template>

<script>
export default {
  name: 'move-to-stage-btn',
  props: {
    link: String,
  }
}
</script>

<style scoped>
.move-to-stage-btn {
}

.move-to-stage-btn>a {
  display: block;
  margin: 2rem auto 0;
  width: fit-content;
  background-color: #fff;
  padding: 0.7rem 1.5rem;
  border-radius: 1rem;
  color: #000;
  box-shadow: 0px 0px 6px 2px #fff;
  transition: all .4s ease;
}

.move-to-stage-btn>a:hover, .move-to-stage-btn>a:active {
  background-color: #aaa;
  box-shadow: 0px 0px 10px 4px #fff;
  color: #fff;
}
</style>
